














import { Component, Mixins } from "vue-property-decorator";
import { IExternalMenuItemConfiguration } from "../../domain/configuration";
import { HeaderPane } from "../panes";
import { DocumentListViewMixin } from "./mixins";
import { DocumentListViewer } from "./viewers";
import { ExternalMenu } from "./viewers/menus";

@Component({
  components: {
    HeaderPane,
    DocumentListViewer,
    ExternalMenu,
  },
})
export default class DocumentListView extends Mixins(DocumentListViewMixin) {
  get externalMenuItems(): IExternalMenuItemConfiguration[] {
    return this.$configuration.behavior.document.list.menu.externalMenus;
  }
}
